export function getCurrentLanguage(): string {
  return localStorage.getItem('currentLanguage') || 'en';
}
